import {Close as CloseIcon} from '@mui/icons-material';
import {Drawer, IconButton} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import SettingsList from './SettingsList.jsx';
import PanelHeader from '@components/panels/PanelHeader.tsx';

const SettingsSidebar = ({open, onClose}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paperAnchorRight': {
          width: 350,
        },
        zIndex: 'modal', //force this drawer be on top of top nav
      }}
    >
      <PanelHeader
        title="Settings"
        action={
          <IconButton
            aria-label="close"
            size="small"
            sx={{
              color: 'action',
            }}
            onClick={() => onClose()}
          >
            <CloseIcon />
          </IconButton>
        }
      />

      <SettingsList />
    </Drawer>
  );
};

SettingsSidebar.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default SettingsSidebar;
